export default function delayLoadFont() {
  const style = document.createElement('style');
  style.innerText = `
    @font-face {
      font-family: 'MiSans-Semibold';
      src: url(${require('./fonts/MiSans-Semibold.woff2')}) format('woff2');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }
    
    @font-face {
      font-family: 'MiSans-Medium';
      src: url(${require('./fonts/MiSans-Medium.otf')}) format('opentype');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }

    @font-face {
      font-family: 'MiSans-Bold';
      src: url(${require('./fonts/MiSans-Bold.woff2')}) format('woff2');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }

    @font-face {
      font-family: 'MiSans-Regular';
      src: url(${require('./fonts/MiSans-Regular.woff2')}) format('woff2');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }

    @font-face {
      font-family: 'MiSans-Thin';
      src: url(${require('./fonts/MiSans-Thin.woff2')}) format('woff2');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }

    @font-face {
      font-family: 'MiSans-Bold';
      src: url(${require('./fonts/MiSans-Bold.woff2')}) format('truetype');
      font-display: swap; /* 关键！避免阻塞渲染 */
    }
  `;
  document.head.appendChild(style);
}
